module.exports = __webpack_public_path__ + "assets/img/img-fv-02.7036fdf7.png";